<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header= "Información de la Tarjeta">
          <b-form>
            <b-form-group
              label="Banco"
              label-for="banco"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="banco"
                :value="banco" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Marca"
              label-for="tarjetaMarca"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="tarjetaMarca"
                :value="tarjetaMarca" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Titular"
              label-for="titular"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="titular"
                v-model.trim="$v.titular.$model" 
                :state="titularValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="titularFeedback">
                {{ titularInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Nro. Tarjeta"
              label-for="numero"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="numero"
                v-model.trim="$v.numero.$model" 
                :state="numeroValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="numeroFeedback">
                {{ numeroInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Vigencia Hasta"
              label-for="fechaVigenciaHasta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaVigenciaHasta" 
                v-model="fechaVigenciaHasta" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Crédito"
              label-for="credito"
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="credito"
                  v-model="credito"
                  value= true
                  unchecked-value= false>
              </b-form-checkbox>
            </b-form-group>

            <b-form-group
              label="Inactivo"
              label-for="inactivo"
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="inactivo"
                  v-model="inactivo"
                  value= true
                  unchecked-value= false>
              </b-form-checkbox>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Banco from '../shared/abmSelect.vue';
import TarjetaMarca from '../shared/abmSelect.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { maxLength } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'tarjetaPlastico/getField',
  mutationType: 'tarjetaPlastico/updateField',
});

export default {
  name: 'TarjetaPlasticoABM',
  components: {
    appBanco: Banco,
    appTarjetaMarca: TarjetaMarca,
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      titularValido: null,
      titularInvalidoMsj: '',
      numeroValido: null,
      numeroInvalidoMsj: '',

      labelCols: 2
    }
  },
  computed: {
    ...mapFields([
      'tarjetaId',
      'banco',
      'tarjetaMarca',

      'id',
      'titular',
      'numero',
      'credito',
      'fechaVigenciaHasta',
      'inactivo'
    ])
  },  
  created() {
    let params = {
      tarjetaId: 0,
      tarjetaPlasticoId: 0
    }

    if (this.$route.params){
      if (this.$route.params.tarjetaId){
        params.tarjetaId = this.$route.params.tarjetaId;
      }
      if (this.$route.params.id){
        params.tarjetaPlasticoId = this.$route.params.id;
      }
    }

    this.showSpinner();
    this.$store.dispatch('tarjetaPlastico/inicializar', params)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'titular' || validarTodos) {
        if (this.$v.titular.$error) {
          this.titularValido = false;
          if (!this.$v.titular.maxLength) {
            this.titularInvalidoMsj = 'El nombre del titular solo puede contener hasta 50 caracteres.';
          }      
        } else {
          this.titularValido = null;
          this.titularInvalidoMsj = '';
        }
      }

      if (campo == 'numero' || validarTodos) {
        if (this.$v.numero.$error) {
          this.numeroValido = false;
          if (!this.$v.numero.maxLength) {
            this.numeroInvalidoMsj = 'El número de tarjeta solo puede contener hasta 20 caracteres.';
          }      
        } else {
          this.numeroValido = null;
          this.numeroInvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        this.showSpinner();
        this.$store.dispatch('tarjetaPlastico/save')
          .then(() => this.showModalMsj('Los cambios se registraron con éxito', this.goList, this.goList, 'light'))
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      } 
    },
    goList() {
      this.$router.push({ name: "TarjetasPlasticos",
                          params: { tarjetaId: this.tarjetaId }});
    },
    bancoActualizado(bancoNombre) {
      this.bancoNombre = bancoNombre;
    },
    tarjetaMarcaActualizada(tarjetaMarcaNombre) {
      this.tarjetaMarcaNombre = tarjetaMarcaNombre;
    },
  },
  validations: {
    titular: {
      maxLength: maxLength(50)
    },
    numero: {
      maxLength: maxLength(20)
    },
  },  
}
</script>

<style>
</style>
